export default function loadReducers(context) {
    var keys = context.keys();
    return keys.reduce(function(acc, key) {
        var reducerName = key.replace(/^\.\/(.*)\.slice\.js$/, "$1"); // เอาชื่อไฟล์เป็น key เช่น './getAllReportPurchaseOrder.slice.js' -> 'getAllReportPurchaseOrder'
        var reducerModule = context(key);
        acc["".concat(reducerName, "Reducer")] = reducerModule.default; // ใส่ key ที่เป็นชื่อของ reducer
        return acc;
    }, {});
}
